import(/* webpackMode: "eager" */ "/vercel/path1/app/(core)/(auth)/layout.tsx");
